import React from 'react'
import '../Home/Home.css'
import Slider from '../Slider/Slider'
import About from '../About/About'
import Layout from '../Layout/Layout'
import Details from '../Details/Details'
import Gallery from '../Gallery/Gallery'
import Price from '../Price/Price'
import Amenities from '../Amenities/Amenities'
import Plan from '../Plan/Plan'
import Location from '../Location/Location'
import Image from '../Image/Image'
import Img from '../Image/Img'
import Slider2 from '../Slider2/Slider2'
import Launch from '../Launch/Launch'
const Home = () => {
  return (
    <>
       <Slider2/>
       <Launch/>
      
        <About/>
        <Img/>
      
        <Layout/>
        <Image/>
        <Details/>
        <Gallery/>
        <Price/>
        <Amenities/>
        <Plan/>
        <Location/>
    </>
  )
}

export default Home